import { isPlatformAXA } from 'utils/showDetails';

export const getTemplate = (societyLanguage: string) => {
  if (isPlatformAXA) {
    return 'sttok-general';
  }

  switch (societyLanguage) {
    case 'es':
      return 'dividends-notification-es';
    case 'en':
      return 'dividends-notification-en';
    case 'fr':
      return 'dividends-notification-fr';
    default:
      return 'dividends-notification-es';
  }
};
